import React from 'react'
import * as actions from '../../actions/TablaBuquesAnunciadosActions'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import { FORM_LINE_UP_BUQUES } from '../../../../config/forms'
import { Tooltip, IconButton } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'

const EdicionAnuncioBuques = (props) => {
  const { fechaAnuncio } = props
  const handleOpen = () => { props.openEdicionAnuncioBuqueDialog(fechaAnuncio) }

  return (
    <Tooltip title={'Editar'}>
      <IconButton onClick={handleOpen} style={{ outline: 'none' }}>
        <EditIcon />
      </IconButton>
    </Tooltip>
  )
}

const selector = formValueSelector(FORM_LINE_UP_BUQUES)

const mapStateToProps = (state) => {
  return {
    toneladas: selector(state, 'toneladas')
  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_LINE_UP_BUQUES,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(EdicionAnuncioBuques))
